document.addEventListener('alpine:init', () => {
    Alpine.data('renderAttraction', () => ({
        html: '',

        init() {
            this.$watch('$store.flyouts.attractionPostId', async (postId) => {
                if (!postId) return;

                this.$store.flyouts.attractionLoading = true;

                try {
                    const formData = new FormData();
                    formData.append('action', 'render_attraction');
                    formData.append('post_id', postId);

                    const response = await fetch(renderAttractionAjax.ajax_url, { method: 'POST', body: formData });
                    const data = await response.json();

                    if (data.html) {
                        this.html = data.html;
                        await this.$nextTick();
                        this.$store.flyouts.open('attraction');
                    }
                } catch (err) {
                    this.html = '';
                } finally {
                    this.$store.flyouts.attractionLoading = false;
                }
            });
        },
    }));
});

//# sourceMappingURL=render-attraction.js.map
